const LazyLoad = ( ( window, undefined ) => {

    var lazy;

    const _privateMethod = function () {
    };

    const init = function () {

        lazy = new Blazy({
            offset: 150,
            success: function(element) {

            },
            error: function(ele, msg) {
                if (msg === 'missing') {

                } else if (msg === 'invalid') {

                }
            }
        });

    };

    const revalidate = function (interval) {

        setTimeout((function() {
            lazy.revalidate();
        }), interval);

    };

    return {
        init: init,
        revalidate: revalidate
    };

})( window );